<template>
  <div>
    <div class="text">
      <div class="d-flex flex-column align-center">
        <blockquote>
          <br>A la demande de la <strong>DREAL Grand Est</strong>
          <br>nous effectuons une enquête sur le ressenti par les habitants de VARANGEVILLE
          <br>des tirs de mines ainsi que des vibrations accompagnant ces tirs.
          <p></p>
          <br><strong>Retrouvez la carte des tirs ressentis:</strong>
          <p></p>
        </blockquote>
      </div>
    </div>
    <div class="map">
      <div ref="mapContainer" style="width: 500px; height: 500px"></div>
    </div>
    <div v-if="errors.length">
      <b>Erreur:</b>
      <ul>
        <li v-for="(error, i) in errors" :key="i">{{ error }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import { Loader } from '@googlemaps/js-api-loader'
/* global google */

export default {
  data () {
    return {
      errors: [],
      tirs: [],
      map: null,
    }
  },
  async mounted () {
    const loader = new Loader({
      apiKey: 'AIzaSyAZu43A_ZI4veRTVvJxYbrG6YS0Tw2x7TM',
      libraries: ['places'],
    })
    await loader.load()
    this.map = new google.maps.Map(this.$refs.mapContainer, {
      center: { lat: 48.6333, lng: 6.3167 },
      zoom: 14,
      mapTypeId: 'terrain',
    })
    this.getTirs()
  },
  methods: {
    getColor (intensity) {
      const baseUrl = 'http://maps.google.com/mapfiles/ms/icons/'
      const colors = ['green', 'green', 'yellow', 'orange', 'pink', 'red']
      const color = colors[parseInt(intensity)] || 'green'
      return baseUrl + color + '-dot.png'
    },
    getTirs () {
      this.$apiclient.getTirsPublic()
        .then(response => {
          if (response.status !== 200) this.errors.push(response.statusText)
          this.tirs = (response.data != null) ? response.data : []
          const geocoder = new google.maps.Geocoder()
          for (const tir of this.tirs) {
            const addressStr = `${tir.address}, ${tir.postal_code} ${tir.town}, France`
            geocoder.geocode({ address: addressStr }, (results, status) => {
              if (status === 'OK') {
                new google.maps.Marker({
                  position: results[0].geometry.location,
                  map: this.map,
                  icon: { url: this.getColor(tir.intensity) },
                })
              }
            })
          }
        })
        .catch(error => {
          if (error.response === undefined) {
            this.errors.push('Error')
          } else {
            this.errors.push(error.response.statusText)
          }
        })
    }
  }
}
</script>
